import React from "react";


interface ConsumptionCardProps {
    title: string;
    highlightedText: string;
    highlightStyle: 'primary' | 'secondary';
    showDetails: boolean;
    detailsLabel: string;
    detailsComponent: string | JSX.Element;
    type: 'wide' | 'narrow';
}

export default function ConsumptionCard(props: ConsumptionCardProps) {

    return (
        <div className={`d-flex flex-column bg-white p-5 u-w-xs-100 ${
                props.type === 'narrow' ? ' u-w-xl-50' : ' flex-xl-row align-items-xl-center justify-content-xl-between'
            } rounded`}>
            <div className={`d-flex flex-column${ props.showDetails ? '' : ' mx-auto'}`}>
                <strong className="u-fs-16 mb-2">{props.title}</strong>
                <div className={
                    `d-flex justify-content-center u-fs-24 font-weight-bold rounded p-1 mb-2 ${
                        props.highlightStyle === 'primary' ? ' bg-primary text-white' : 'bg-secondary-light text-dark'}`
                    }
                >{ props.highlightedText }</div>
            </div>
            { props.showDetails ? <div className={`d-flex flex-column`}>
                <span className="u-fs-14 text-gray-700">{ props.detailsLabel }</span>
                <strong className="u-fs-16">{ props.detailsComponent }</strong>
            </div> : null }
        </div>
    )
}